import { Spinner } from "./ui/spinner"

export function LoadingSection() {
  return (
    <section
      className="flex size-full max-h-[calc(100vh-64px)] items-center justify-center"
      data-testid="loading-indicator"
    >
      <Spinner className="size-12" />
    </section>
  )
}
